import React, { useContext, useEffect, useRef, useState } from "react";
//import "antd/dist/antd.css";
import "./index.css";
//import { Layout } from "antd";
import "./App.css";
import history from "./contexto/history";
import AuthApi from "./contexto/AuthApi";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import Principal from "./paginas/Principal";
import Producto3D from "./paginas/Producto3D";
import Producto3DAR from "./paginas/Producto3DAR";
import Test from "./paginas/Test";
import CryptoJs from "crypto-js";
import Cookies from "js-cookie";
import EmpaticaDescription from "./componentes/camino/EmpaticaDescription";
import ApiReference from "./paginas/ApiReference";
import Privado from "./paginas/Privado";
import Publico from "./paginas/Publico";
import Consultoria from "./paginas/Consultoria";
import IntroVideo from "./componentes/IntroVideo";
import VisualizadorPDF from "./paginas/VisualizadorPDF";
import PdfViewer from "./paginas/PdfViewer";
import SimuladorCajero from "./paginas/SimuladorCajero";
import EcosistemaPos from "./paginas/EcosistemaPos";
import DemoEmpaticaPos from "./paginas/DemoEmpaticaPos";
import ApiIntegraciones from "./paginas/ApiIntegraciones";
import ConnectApiDocs from "./paginas/ConnectApiDocs";
import DeviceApiDocs from "./paginas/DeviceApiDocs";
import EmpaticaNetPay from "./paginas/EmpaticaNetPay";

const App = () => {
  const [auth, setAuth] = useState({
    authentication: false,
    id: "",
    celular: "",
    token: "",
  });


  const leerCookie = () => {
    var user = Cookies.get("sesion");
    if (user != null) {

    }
  }

  useEffect(() => {
    // leerCookie();
  }, []);

  return (
    <AuthApi.Provider value={{ auth, setAuth }}>
      <Router history={history}>
        <div>
          <Routes />
        </div>
      </Router>
    </AuthApi.Provider>
  );

}

const Routes = (props) => {
  const Auth = useContext(AuthApi);
  return (
    <Switch>
      <UnProtectedRoute
        exact
        path="/empaticavideo"
        component={IntroVideo}
        auth={Auth.auth}
      />
      <UnProtectedRoute
        exact
        path="/"
        component={Principal}
        auth={Auth.auth}
      />
      <UnProtectedRoute
        exact
        path="/empaticapage"
        component={Principal}
        auth={Auth.auth}
      />
      <UnProtectedRoute
        exact
        path="/Producto3D/:modelo"
        component={Producto3D}
        auth={Auth.auth}
      />
      <UnProtectedRoute
        exact
        path="/Producto3DAR"
        component={Producto3DAR}
        auth={Auth.auth}
      />
      <UnProtectedRoute
        exact
        path="/Test"
        component={Test}
        auth={Auth.auth}
      />
      <UnProtectedRoute
        exact
        path="/empatica-description"
        component={EmpaticaDescription}
        auth={Auth.auth}
      />

      {/* <UnProtectedRoute
        exact
        path="/ApiReference"
        component={ApiReference}
        auth={Auth.auth}
      />*/}

      <Route
        exact
        path="/ApiReference"
        render={() => <Redirect to="/ApiIntegraciones" />}
      />

      <UnProtectedRoute
        exact
        path="/QPMini/ApiReference"
        component={ApiReference}
        auth={Auth.auth}
      />

      <UnProtectedRoute
        exact
        path="/empaticapage/privado"
        component={Privado}
        auth={Auth.auth}
      />
      <UnProtectedRoute
        exact
        path="/empaticapage/publico"
        component={Publico}
        auth={Auth.auth}
      />
      <UnProtectedRoute
        exact
        path="/empaticapage/consultoria"
        component={Consultoria}
        auth={Auth.auth}
      />

      <UnProtectedRoute
        exact
        path="/privado"
        component={Privado}
        auth={Auth.auth}
      />
      <UnProtectedRoute
        exact
        path="/publico"
        component={Publico}
        auth={Auth.auth}
      />
      <UnProtectedRoute
        exact
        path="/consultoria"
        component={Consultoria}
        auth={Auth.auth}
      />
      <UnProtectedRoute
        exact
        path="/privado/documentos/:archivo"
        component={PdfViewer}
        auth={Auth.auth}
      />
      <UnProtectedRoute
        exact
        path="/publico/documentos/:archivo"
        component={PdfViewer}
        auth={Auth.auth}
      />

      <UnProtectedRoute
        exact
        path="/cajeros/simulador"
        component={SimuladorCajero}
        auth={Auth.auth}
      />

      <UnProtectedRoute
        exact
        path="/ecosistemapos"
        component={EcosistemaPos}
        auth={Auth.auth}
      />

      <UnProtectedRoute
        exact
        path="/demoempaticapos"
        component={DemoEmpaticaPos}
        auth={Auth.auth}
      />

      <UnProtectedRoute
        exact
        path="/ApiIntegraciones"
        component={ApiIntegraciones}
        auth={Auth.auth}
      />

      <UnProtectedRoute
        path="/developers/connect-api"
        component={ConnectApiDocs}
        auth={Auth.auth}
      />

      <UnProtectedRoute
        path="/developers/device-api"
        component={DeviceApiDocs}
        auth={Auth.auth}
      />

      <UnProtectedRoute
        path="/alianzas/netpay"
        component={EmpaticaNetPay}
        auth={Auth.auth}
      />

    </Switch>

  );
};

const ProtectedRoute = ({
  auth,
  component: Component,
  ...rest
}) => {
  console.log("Protected: ", auth);
  // Auth contiene la información del usuario
  return (
    <Route
      {...rest}
      render={() =>
        auth.authentication ? (
          <Component
            id={auth.id}
            correo={auth.correo}
            token={auth.token}
            user={auth}
          />
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
};

const UnProtectedRoute = ({
  auth,
  component: Component,
  ...rest
}) => {
  console.log("Unprotected: ", auth);
  // Auth contiene la información del usuario
  return (
    <Route
      {...rest}
      render={() =>
        !auth.authentication ? (
          <Component />
        ) : (
          <Redirect
            to="/Dashboard"
            token={auth.token}
            user={auth}
          />
        )
      }
    />
  );
};

export default App;

